import { render, staticRenderFns } from "./GenericTableLocations.vue?vue&type=template&id=5fe42d33"
import script from "./GenericTableLocations.vue?vue&type=script&lang=ts"
export * from "./GenericTableLocations.vue?vue&type=script&lang=ts"
import style0 from "./GenericTableLocations.vue?vue&type=style&index=0&id=5fe42d33&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports